module.exports = __webpack_public_path__ + "sqlite.e24f9e56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/db/img/sqlite.svg
// module id = mFOd
// module chunks = 1